<template>
  <div class="category my-5">
    <div
      class="category__content | d-flex align-items-center justify-content-between mb-4"
    >
      <h4>{{ $auth.setting.app_layout[0].home_page_category_title }}</h4>
    </div>

    <!-- Actual Content -->
    <div class="category__grid">
      <router-link
        :to="{
          name: 'vendor',
          params: { restaurant_name: restaurant.slug },
        }"
        class="category__box"
        v-for="category in categories"
        :key="category.id"
      >
        <img :src="category.image" :alt="category.name" />
        <div class="category__content">
          <h3>{{ category.name }}</h3>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCategory",
  props: ["restaurant","categories"],
  data() {
    return {
    };
  },
};
</script>

<style lang="css">
.category__grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
}

.category__box {
  border-radius: 8px;
  min-height: 150px;
  position: relative;
  overflow: hidden;
}

.category__box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.category__box h3 {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  color: #fff;
  margin: auto;
  text-align: center;
  font-size: 16px;
  z-index: 9;
}

.category__box::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(to top, rgba(240, 87, 2, 0.6) 10%, transparent);
}

/* Skeleton/Skeleton Styles */
.category__skeleton {
  border-radius: 10px;
  overflow: hidden;
}

.skeleton-item {
  border-radius: 10px;
  width: 100% !important;
}

/* Shimmer Animation */
.skeleton-item::v-deep .skeleton-loader {
  animation: shimmer 2s infinite linear;
  background: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-size: 1000px 100%;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

/* Responsive Design */
@media (max-width: 1280px) {
  .category__grid {
    grid-template-columns: repeat(7, 1fr);
  }
}

@media (max-width: 1199px) {
  .category__grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (max-width: 991px) {
  .category__grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 767px) {
  .category__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .category__box,
  .category__skeleton {
    min-height: 110px;
  }
}
</style>